import { styled } from '@mui/material';

import { RADIUS, LINE_WIDTH, MAIN_COLOR, SECONDARY_COLOR, BACKGROUND } from '@constants/chart';

const BEFORE_AFTER_COMMON_STYLES = {
  content: "''",
  position: 'absolute',
  width: `${LINE_WIDTH}px`,
  height: `${LINE_WIDTH}px`,
  bottom: 0,
  borderRadius: '0 0 50% 50%',
  zIndex: 11,
};

export const sxStyles = {
  wrapper: {
    padding: `${LINE_WIDTH}px ${LINE_WIDTH}px 0`,
    overflow: 'hidden',
    height: `${RADIUS + LINE_WIDTH}px`,
  },
  container: {
    height: `${RADIUS}px`,
    width: `${RADIUS * 2}px`,
    position: 'relative',
    opacity: 1,
  },
  data: {
    position: 'absolute',
    left: '50%',
    top: '55%',
    transform: 'translate(-50%, -50%)',
  },
  start: {
    position: 'absolute',
    bottom: '-5px',
    left: `calc(${LINE_WIDTH}px + 0.25rem)`,
    zIndex: 11,
  },
  end: {
    position: 'absolute',
    bottom: '-5px',
    right: `calc(${LINE_WIDTH}px + 0.25rem)`,
    zIndex: 11,
  },
};

export const StyledCircle = styled('div', {
  shouldForwardProp: (prop) => prop !== 'percentage',
})<{ percentage: number }>(({ percentage }) => ({
  width: `${RADIUS * 2}px`,
  height: `${RADIUS * 2}px`,
  borderRadius: '300px',
  top: 0,
  left: 0,
  transition: 'background-color 0.2s ease-in-out',
  opacity: 0.9,
  transform: 'rotate(-90deg)',
  background: `conic-gradient(${MAIN_COLOR} ${(percentage / 100) * 180}deg, ${SECONDARY_COLOR} ${
    (percentage / 100) * 180
  }deg 180deg, ${BACKGROUND} 180deg)`,
}));

export const StyledCutOut = styled('div')(() => ({
  position: 'absolute',
  top: `${LINE_WIDTH}px`,
  left: `${LINE_WIDTH}px`,
  right: `${LINE_WIDTH}px`,
  bottom: 0,
  borderRadius: '290px 290px 0px 0px',
  background: '#fff',

  '&:before': {
    ...BEFORE_AFTER_COMMON_STYLES,
    left: `-${LINE_WIDTH}px`,
    background: MAIN_COLOR,
  },

  '&:after': {
    ...BEFORE_AFTER_COMMON_STYLES,
    right: `-${LINE_WIDTH}px`,
    background: SECONDARY_COLOR,
  },
}));

export const StyledPoint = styled('div', {
  shouldForwardProp: (prop) => prop !== 'percentage',
})<{ xcoordinate: number; ycoordinate: number }>(({ xcoordinate, ycoordinate }) => ({
  position: 'absolute',
  left: xcoordinate,
  top: ycoordinate,
  height: '8px',
  width: '8px',
  borderRadius: '100%',
  zIndex: 20,
  cursor: 'pointer',
  background: BACKGROUND,
  boxShadow: `0 0 0 4px ${MAIN_COLOR},  0 0px 0 4px rgba(0,0,0,.05)`,
}));

export const StyledLine = styled('div')(() => ({
  position: 'absolute',
  height: `${LINE_WIDTH / 2}px`,
  background: BACKGROUND,
  width: '100%',
  left: 0,
  bottom: 0,
  zIndex: 10,
}));
